<template>
    <div class="pt-4">
        <p v-html="$ti('import.importdetailscontestants', { count: validRows }, true)"></p>

        <p v-if="data.find((x) => x[1].length > 0) != null">{{ $tm('import.itemstobecreated') }}</p>
        <div class="d-flex flex-row flex-wrap">
            <template
                v-for="(d, i) in data"
                :key="i"
            >
                <div
                    class="w-md-50"
                    v-if="d[1].length > 0"
                >
                    <h5>{{ $tm(d[0].toString()) }}</h5>
                    <ul class="list">
                        <li
                            v-for="(v, j) in d[1]"
                            :key="j"
                        >
                            {{ v }}
                        </li>
                    </ul>
                </div>
            </template>
        </div>

        <template v-if="importFormatValue != undefined && importformat?.format?.DataProvider == 'Generic'">
            <h4 class="mt-5">{{ $tm('contestantimport.newformattitle') }}</h4>
            <NewImportFormat
                v-model="importFormatValue"
                :formatList="[]"
            />
        </template>
    </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import type { ContestantImportDetails } from '../Import';
import { $ti, $tm } from '@/locize';
import NewImportFormat from './NewImportFormat.vue';
import type { ImportFormat } from '@/objects/generated';

const props = defineProps<{
    /**
     * Contains all the details for each row
     */
    value: ContestantImportDetails[];

    /**
     * The number of valid rows in the import
     */
    validRows: number;

    /**
     * The number of invalid rows that we are ignoring in the import
     */
    invalidRows: number;

    importformat?: { name: string; format?: ImportFormat };
}>();

const importFormatValue = ref(props.importformat);

const filteredRaces = ref<string[]>([]);
const filteredCategories = ref<string[]>([]);
const filteredGroups = ref<string[]>([]);
const filteredTeams = ref<string[]>([]);

/**
 * Create a dataset to present the details in a more readable way.
 * this will create columns for each type of data that will be generated
 */
const data = computed(() => {
    const data = [];
    data.push(['import.races', filteredRaces.value]);
    data.push(['import.categories', filteredCategories.value]);
    data.push(['import.groups', filteredGroups.value]);
    data.push(['import.teams', filteredTeams.value]);

    return data;
});

/**
 * We go through the details and extract the unique values for each field.
 */
const parseDetails = () => {
    const races: string[] = [];
    const categories: string[] = [];
    const groups: string[] = [];
    const teams: string[] = [];
    props.value.forEach((detail) => {
        if (!detail) {
            return;
        }

        if (detail.RaceGenerated && detail.Race != null && detail.Race.trim() != '' && !races.includes(detail.Race)) {
            races.push(detail.Race);
        }

        if (detail.CategoryGenerated && detail.Category != null && detail.Category.trim() != '' && !categories.includes(detail.Category)) {
            categories.push(detail.Category);
        }

        if (detail.GroupGenerated && detail.Group != null && detail.Group.trim() != '' && !groups.includes(detail.Group)) {
            groups.push(detail.Group);
        }

        if (detail.TeamGenerated && detail.Team != null && detail.Team.trim() != '' && !teams.includes(detail.Team)) {
            teams.push(detail.Team);
        }
    });
    filteredRaces.value = races.sort((a, b) => a.localeCompare(b));
    filteredCategories.value = categories.sort((a, b) => a.localeCompare(b));
    filteredGroups.value = groups.sort((a, b) => a.localeCompare(b));
    filteredTeams.value = teams.sort((a, b) => a.localeCompare(b));
};

parseDetails();
</script>
